// libs
import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import "../../assets/css/form.css";
import "react-datepicker/dist/react-datepicker.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Loading from '../../components/loading';
// components 
import PincodeFormModal from './pincode-form-modal';
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from "../../config/index";

function PincodeListModal({urlaccountid, setshowformmodalbox, rowdata, token, orginfo}) {

    const [PincodeList, setPincodeList] = useState([]);
    const [Show, setShow] = useState(false);
    const [ShowPincodeFormModal, setShowPincodeFormModal] = useState(false);
    const [EditPincodeData, setEditPincodeData] = useState(null);
    const [IsLoading, setIsLoading] = useState(true);

    const hideModal = () => {
        setShow(false);
        setshowformmodalbox(false)
	}

    const fetchPincodes = async () => {
        if (rowdata.ppid) {
            let apiCall = await ajaxCall.getCall(`${config.api.generic}/shipping-price/pincodes`, {
                accountId: urlaccountid,
                shippingpriceRowId: rowdata.ppid || 0
            }, token);
            if(apiCall && apiCall.status) {
                let pincodes = apiCall.context.message.data.map(item => ({pk_id: item.pk_id, pincode: item.pincode}));
                setPincodeList(pincodes);
                setIsLoading(false);
            } else {
                setPincodeList([]);
                setIsLoading(false);
            }
        }
    }

    const handleDeletePincode = async (pincodeObj) => {
        let apiCall = await ajaxCall.deleteCall(`${config.api.generic}/shipping-price/pincodes`, {
            accountId: urlaccountid,
            shippingpriceRowId: rowdata.ppid || 0,
            pincode: pincodeObj.pincode
        }, token);
        if(apiCall && apiCall.status) {
            let updatedPincodes = PincodeList.filter(v => v.pk_id !== pincodeObj.pk_id);
            setPincodeList(updatedPincodes);
            toast.success("Pincode deleted successfully");
        } else {
            toast.error("Sorry something went wrong while deleting pincode :(");
        }
    }

    const handleEditPincode = (pincodeObj) => {
        setEditPincodeData(pincodeObj);
        setShowPincodeFormModal(true);
    }

    const PrintPincodes = () => {
        if(PincodeList && PincodeList.length > 0) {
            return <>
                <Col md="12">
                    {PincodeList.map((v, i) => {
                        return <div key={v.pk_id} className="d-flex align-items-center mb-2">
                            <div className="border rounded p-2 me-2" style={{minWidth: '80px'}}>{v.pincode}</div>
                            <Button variant="primary" size="sm" onClick={() => handleEditPincode(v)} className="p-0 px-2 me-2">Edit</Button>
                            <Button variant="danger" size="sm" onClick={() => handleDeletePincode(v)} className="p-0 px-2">Delete</Button>
                        </div>
                    })}
                </Col>
            </>
        } else {
            return <Col md="12"><div className="text-center fs-16rem">No pincode mapped for this shipping price yet.</div></Col>
        }
    }

    const handleAddPincode = () => {
        setEditPincodeData(null);
        setShowPincodeFormModal(true);
    }

    const handleRefreshData = () => {
        setShowPincodeFormModal(false);
        setEditPincodeData(null);
        fetchPincodes();
    }

    React.useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }
        fetchPincodes();
        loadComponent();
    }, []);

    return (
        <>
            <Modal show={Show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header className="d-flex justify-content-between align-items-start">
                    <Modal.Title className="mb-0">
                        <div>{`Update Pincode`}</div>
                        <div className="fs-12rem">{`Shipping Price: ${rowdata?.shippingPrice || 'N/A'} | Is Cod: ${rowdata?.isCod ? 'Yes' : 'No'} | Is Default: ${rowdata?.isDefault ? 'Yes' : 'No'}`}</div>
                    </Modal.Title>
                    <button type="button" onClick={handleAddPincode} className="btn btn-sm btn-secondary ms-2 flex-shrink-0">Add Pincode</button>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Row>
                                {IsLoading ? <Col md="12" className="text-center"><Loading /></Col> : <PrintPincodes />}
                            </Row>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="fs-14rem" onClick={hideModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {(ShowPincodeFormModal) ? <PincodeFormModal
                urlaccountid={urlaccountid}
                shippingpriceRowId={rowdata?.ppid || 0}
                pincodeRowId={EditPincodeData ? EditPincodeData.pk_id : null}
                editPincode={EditPincodeData ? EditPincodeData.pincode : ""}
                setshowpincodeformmodal={setShowPincodeFormModal}
                refreshdata={handleRefreshData}
                token={token}
            /> : null}
        </>
    )
}

export default PincodeListModal;
